import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class DetectScreenService {
  public getScreen(): number {
    return screen.width;
  }
}
